export const foods = [
  {
    name: "Arsik",
    description: "Ikan mas yang dimasak dengan bumbu khas Batak",
    ingredients: "Ikan mas, andaliman, jahe, kunyit, cabai",
    occasion: "Acara adat dan perayaan",
    region: "Tapanuli Utara",
    significance: "Makanan wajib dalam upacara adat",
    image: "https://image.idntimes.com/post/20220511/207652216-876812236238926-4998946857659635657-n-5a9ba10ccf54a458099c11441d86bb79.jpg",
    references: [
      {
        title: "Arsik - Wikipedia",
        url: "https://id.wikipedia.org/wiki/Arsik",
      },
      {
        title: "Resep Ikan Arsik Khas Batak - DentistChef",
        url: "https://dentistvschef.wordpress.com/tag/indonesian-fish-recipe/",
      },
    ],
  },


  {
    name: "Saksang",
    description: "Daging babi atau anjing yang dimasak dengan bumbu rica-rica",
    ingredients: "Daging, andaliman, jahe, kunyit, darah",
    occasion: "Upacara besar dan perayaan",
    region: "Seluruh Batak",
    significance: "Makanan sakral dalam ritual adat",
    image: "https://awsimages.detik.net.id/community/media/visual/2020/07/22/hoax-mie-instan-saksang-babi-1.jpeg?",
    references: [
      {
        title: "Saksang - Wikipedia",
        url: "https://en.wikipedia.org/wiki/Saksang",
      },
      {
        title: "Saksang - Bataknese Popular Dishes",
        url: "https://horastour.wordpress.com/2013/07/17/saksang/",
      },
    ],
  },


  {
    name: "Dali ni Horbo",
    description: "Susu kerbau yang difermentasi",
    ingredients: "Susu kerbau segar",
    occasion: "Makanan sehari-hari dan obat tradisional",
    region: "Tapanuli",
    significance: "Sumber protein dan obat tradisional",
    image: "https://upload.wikimedia.org/wikipedia/id/0/09/DaliNiHorbo.jpg",
    references: [
      {
        title:
          "Dali ni Horbo - Wikipedia",
        url: "https://id.wikipedia.org/wiki/Dali_ni_horbo",
      },
      {
        title:
          "Dali ni Horbo: Warisan Kuliner Batak - Kompasiana",
        url: "https://www.kompasiana.com/anggiasihkusuma/5fbcd61fd541df33b35d5a77/dali-ni-horbo-warisan-kuliner-batak",
      },
    ],
  },
];
